export enum PackageSessionStatus {
    Active = 1
}
